/**
 * FeatureGate — Prevents rendering of features unavailable to this user.
 *
 * SECURITY NOTE: This is a UX layer only. Backend must enforce
 * all restrictions independently via middleware. Never rely on
 * FeatureGate alone for security.
 *
 * Defaults to NOT rendering (safe) while auth is loading.
 */

import React from 'react';
import { useUserContext, type Features } from '../hooks/useUserContext';

type FeatureGateProps = {
  feature: keyof Features;
  children: React.ReactNode;
  fallback?: React.ReactNode;
};

export function FeatureGate({ feature, children, fallback = null }: FeatureGateProps) {
  const { features, authLoading, profileLoaded } = useUserContext();

  if (authLoading || !profileLoaded) return null;

  if (!features[feature]) return <>{fallback}</>;

  return <>{children}</>;
}
